export default __webpack_public_path__ + "static/media/indianapolis-svg.dc321900.svg";